import { Job } from './types';

export const LABELS: Record<Job, string> = {
  push: 'export',
  pull: 'import'
};
